import React, { ChangeEvent, FormEvent, useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import Box from "@material-ui/core/Box";
import Card from "@material-ui/core/Card";
import CardHeader from "@material-ui/core/CardHeader";
import CardContent from "@material-ui/core/CardContent";
import CardActions from "@material-ui/core/CardActions";
import InputLabel from "@material-ui/core/InputLabel";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import { connect } from "react-redux";
import { ColorPicker, createColor, Color } from "material-ui-color";
import { TextField, Typography, Chip, Switch } from "@material-ui/core";
import {
  fetchAccountTheme,
  fetchOrgTheme,
  updateAccountTheme,
  updateAccountVisibility,
  updateOrgTheme,
} from "../../actions/accountActions";
import { Star } from "@material-ui/icons";
import { AccountTheme } from "../../shared/types";
import { getUserToken } from "../../shared/api";
import { RootState } from "../../store/store";
import CircularProgress from "@material-ui/core/CircularProgress";
import { useAppSelector } from "../../hooks/useAppSelector";
import Link from "@material-ui/core/Link";
import { useAppDispatch } from "../../hooks/useAppDispatch";

type ThemeProps = {
  theme?: AccountTheme;
  isAllowedToEdit?: boolean;
  isSettings?: boolean;
};
function Theme({ theme, isAllowedToEdit }: ThemeProps) {
  const [navcolor, setNavcolor] = useState<Color>();
  const [navtextcolor, setNavtextcolor] = useState<Color>();
  const [bgcolor, setBgcolor] = useState<Color>();
  const [hideTitle, setHideTitle] = useState<boolean>(false);
  const [customDomain, setCustomDomain] = useState<string>("");
  const [customDomainIsValid, setCustomDomainIsValid] =
    useState<boolean>(false);
  const account = useAppSelector((state) => state.selected.account)!;
  const isLoading = useAppSelector(
    (state) => state.accounts.updateAccountLoading
  );

  const classes = useStyles();
  const dispatch = useAppDispatch();
  const { id } = useParams();

  const fetchOrganisationTheme = async () => {
    const token = await getUserToken();
    if (window.location.href.indexOf("account") >= 0) {
      dispatch(fetchAccountTheme(token!, id));
    } else {
      dispatch(fetchOrgTheme(token!, id));
    }
  };

  useEffect(() => {
    fetchOrganisationTheme();
  }, []);

  useEffect(() => {
    if (theme) {
      setNavcolor(createColor(theme.navColour));
      setNavtextcolor(createColor(theme.colour1));
      if (theme.colour2) {
        setBgcolor(createColor(theme.colour2));
      }
      setHideTitle(theme.hideTitle);
    }
  }, [theme]);

  const domainRegex = new RegExp(
    `^(?:https?:\\/\\/)?(?:www\\.)?([^\\s\\:\\/\\?\\[\\]\\@\\!\\$\\&\\'\\(\\)\\*\\+\\,\\;\\=\\<\\>\\#\\%\\"\\{\\}\\|\\\\\\^\\\`]{1,63}\\.(?:com|org|net|int|edu|gov|mil|arpa|ac|ad|ae|af|ag|ai|al|am|an|ao|aq|ar|as|at|au|aw|ax|az|ba|bb|bd|be|bf|bg|bh|bi|bj|bl|bm|bn|bo|bq|br|bs|bt|bv|bw|by|bz|ca|cc|cd|cf|cg|ch|ci|ck|cl|cm|cn|co|cr|cu|cv|cw|cx|cy|cz|de|dj|dk|dm|do|dz|ec|ee|eg|eh|er|es|et|eu|fi|fj|fk|fm|fo|fr|ga|gb|gd|ge|gf|gg|gh|gi|gl|gm|gn|gp|gq|gr|gs|gt|gu|gw|gy|hk|hm|hn|hr|ht|hu|id|ie|il|im|in|io|iq|ir|is|it|je|jm|jo|jp|ke|kg|kh|ki|km|kn|kp|kr|kw|ky|kz|la|lb|lc|li|lk|lr|ls|lt|lu|lv|ly|ma|mc|md|me|mf|mg|mh|mk|ml|mm|mn|mo|mp|mq|mr|ms|mt|mu|mv|mw|mx|my|mz|na|nc|ne|nf|ng|ni|nl|no|np|nr|nu|nz|om|pa|pe|pf|pg|ph|pk|pl|pm|pn|pr|ps|pt|pw|py|qa|re|ro|rs|ru|rw|sa|sb|sc|sd|se|sg|sh|si|sj|sk|sl|sm|sn|so|sr|ss|st|su|sv|sx|sy|sz|tc|td|tf|tg|th|tj|tk|tl|tm|tn|to|tp|tr|tt|tv|tw|tz|ua|ug|uk|um|us|uy|uz|va|vc|ve|vg|vi|vn|vu|wf|ws|ye|yt|za|zm|zw|الجزائر|xn--lgbbat1ad8j|հայ|xn--y9a3aq|বাংলা|xn--54b7fta0cc|бел|xn--90ais|бг|xn--90ae|中国|xn--fiqs8s|中國|xn--fiqz9s|مصر|xn--wgbh1c|ею|xn--e1a4c|გე|xn--node|ελ|xn--qxam|香港|xn--j6w193g|भारत|xn--h2brj9c|بھارت|xn--mgbbh1a71e|భారత్|xn--fpcrj9c3d|ભારત|xn--gecrj9c|ਭਾਰਤ|xn--s9brj9c|இந்தியா|xn--xkc2dl3a5ee0h|ভারত|xn--45brj9c|ಭಾರತ|xn--2scrj9c|ഭാരതം|xn--rvc1e0am3e|ভাৰত|xn--45br5cyl|ଭାରତ|xn--3hcrj9c|بارت|xn--mgbbh1a|भारतम्|xn--h2breg3eve|भारोत|xn--h2brj9c8c|ڀارت|xn--mgbgu82a|ایران|xn--mgba3a4f16a|عراق|xn--mgbtx2b|الاردن|xn--mgbayh7gpa|қаз|xn--80ao21a|澳门|xn--mix082f|澳門|xn--mix891f|мкд|xn--d1alf|مليسيا|xn--mgbx4cd0ab|мон|xn--l1acc|المغرب|xn--mgbc0a9azcg|عمان|xn--mgb9awbf|پاکستان|xn--mgbai9azgqp6j|فلسطين|xn--ygbi2ammx|قطر|xn--wgbl6a|рф|xn--p1ai|السعودية|xn--mgberp4a5d4ar|срб|xn--90a3ac|新加坡|xn--yfro4i67o|சிங்கப்பூர்|xn--clchc0ea0b2g2a9gcd|한국|xn--3e0b707e|ලංකා|xn--fzc2c9e2c|இலங்கை|xn--xkc2al3hye2a|سودان|xn--mgbpl2fh|سورية|xn--ogbpf8fl|台湾|xn--kprw13d|台灣|xn--kpry57d|ไทย|xn--o3cw4h|تونس|xn--pgbs0dh|укр|xn--j1amh|امارات|xn--mgbaam7a8h|اليمن|xn--mgb2ddes|abc|academy|accountant|accountants|active|actor|ads|adult|aero|agency|airforce|analytics|apartments|app|archi|army|art|associates|attorney|auction|audible|audio|author|auto|autos|aws|baby|bananarepublic|band|bank|bar|barefoot|bargains|baseball|basketball|beauty|beer|best|bestbuy|bet|bible|bid|bike|bingo|bio|biz|black|blackfriday|blockbuster|blog|blue|boo|book|boots|bot|boutique|box|broadway|broker|build|builders|business|buy|buzz|cab|cafe|call|cam|camera|camp|cancerresearch|capital|car|cards|care|career|careers|cars|case|cash|casino|catering|catholic|center|ceo|cfd|channel|chat|cheap|christmas|church|cipriani|circle|city|claims|cleaning|click|clinic|clothing|cloud|club|coach|codes|coffee|college|community|company|compare|computer|condos|construction|consulting|contact|contractors|cooking|cool|coop|country|coupon|coupons|courses|credit|creditcard|cruise|cricket|cruises|dad|dance|data|date|dating|day|deal|deals|degree|delivery|democrat|dental|dentist|design|dev|diamonds|diet|digital|direct|directory|discount|diy|docs|doctor|dog|domains|dot|download|drive|duck|earth|eat|eco|education|email|energy|engineer|engineering|enterprises|equipment|esq|estate|events|exchange|expert|exposed|express|fail|faith|family|fan|fans|farm|fashion|fast|feedback|film|final|finance|financial|fire|fish|fishing|fit|fitness|flights|florist|flowers|fly|foo|food|foodnetwork|football|forsale|forum|foundation|free|frontdoor|fun|fund|furniture|fyi|gallery|game|games|garden|gift|gifts|gives|glass|global|gold|golf|gop|graphics|green|gripe|grocery|group|guide|guitars|guru|hair|hangout|health|healthcare|help|here|hiphop|hiv|hockey|holdings|holiday|homegoods|homes|homesense|horse|hospital|host|hosting|hot|hotels|house|how|ice|industries|info|ing|ink|institute|insurance|insure|international|investments|jewelry|jobs|joy|kim|kitchen|land|latino|law|lawyer|lease|legal|lgbt|life|lifeinsurance|lighting|like|limited|limo|link|live|living|loan|loans|locker|lol|lotto|love|luxury|makeup|management|map|market|marketing|markets|mba|med|media|meet|meme|memorial|men|menu|mint|mobi|mobile|mobily|moe|mom|money|mortgage|motorcycles|mov|movie|museum|name|navy|network|new|news|ngo|ninja|now|observer|off|one|ong|onl|online|ooo|open|organic|origins|page|partners|parts|party|pay|pet|pharmacy|phone|photo|photography|photos|physio|pics|pictures|pid|pin|pink|pizza|place|plumbing|plus|poker|porn|post|press|prime|pro|productions|prof|promo|properties|property|protection|pub|qpon|racing|radio|read|realestate|realtor|realty|recipes|red|rehab|reit|ren|rent|rentals|repair|report|republican|rest|restaurant|review|reviews|rich|rip|rocks|rodeo|room|rugby|run|safe|sale|save|scholarships|school|science|search|secure|security|select|services|sex|sexy|shoes|shop|shopping|show|showtime|silk|singles|site|ski|skin|sky|sling|smile|soccer|social|software|solar|solutions|song|space|spot|spreadbetting|storage|store|stream|studio|study|style|sucks|supplies|supply|support|surf|surgery|systems|talk|tattoo|tax|taxi|team|tech|technology|tel|tennis|theater|theatre|tickets|tips|tires|today|tools|top|tours|town|toys|trade|trading|training|travel|travelersinsurance|trust|tube|tunes|uconnect|university|vacations|ventures|vet|video|villas|vip|vision|vodka|vote|voting|voyage|wang|watch|watches|weather|webcam|website|wed|wedding|whoswho|wiki|win|wine|winners|work|works|world|wow|wtf|xxx|xyz|yachts|yoga|you|zero|zone|shouji|tushu|wanggou|weibo|xihuan|arte|clinique|luxe|maison|moi|rsvp|sarl|epost|gmbh|haus|immobilien|jetzt|kaufen|kinder|reise|reisen|schule|versicherung|desi|shiksha|casa|immo|moda|voto|bom|passagens|abogado|gratis|futbol|hoteles|juegos|ltda|soy|tienda|uno|viajes|vuelos|在线|xn--3ds443g|中文网|xn--fiq228c5hs|移动|xn--6frz82g|网址|xn--ses554g|网络|xn--io0a7i|公司|xn--55qx5d|商城|xn--czru2d|机构|xn--nqv7f|我爱你|xn--6qq986b3xl|商标|xn--czr694b|世界|xn--rhqv96g|集团|xn--3bst00m|дети|xn--d1acj3b|католик|ком|xn--j1aef|онлайн|xn--80asehdb|орг|xn--c1avg|сайт|xn--80aswg|संगठन|xn--i1b6b1a6a2e|कॉम|नेट|닷컴|닷넷|קום‎|xn--9dbq2a|みんな|xn--q9jyb4c|セール|ファッション|ストア|ポイント|クラウド|コム|คอม|africa|capetown|durban|joburg|abudhabi|arab|asia|doha|dubai|krd|kyoto|nagoya|okinawa|osaka|ryukyu|taipei|tatar|tokyo|yokohama|alsace|amsterdam|bcn|barcelona|bayern|berlin|brussels|budapest|bzh|cat|cologne|corsica|cymru|eus|frl|gal|gent|hamburg|helsinki|irish|ist|istanbul|koeln|london|madrid|moscow|nrw|paris|ruhr|saarland|scot|stockholm|swiss|tirol|vlaanderen|wales|wien|zuerich|boston|miami|nyc|quebec|vegas|kiwi|melbourne|sydney|lat|rio|佛山|xn--1qqw23a|广东|москва|xn--80adxhks|рус|ابوظبي|‏عرب‎|aaa|aarp|abarth|abb|abbott|abbvie|accenture|aco|aeg|aetna|afl|agakhan|aig|aigo|airbus|airtel|akdn|alfaromeo|alibaba|alipay|allfinanz|allstate|ally|alstom|americanexpress|amex|amica|android|anz|aol|apple|aquarelle|aramco|audi|auspost|axa|azure|baidu|barclaycard|barclays|bauhaus|bbc|bbt|bbva|bcg|bentley|bharti|bing|blanco|bloomberg|bms|bmw|bnl|bnpparibas|boehringer|bond|booking|bosch|bostik|bradesco|bridgestone|brother|bugatti|cal|calvinklein|canon|capitalone|caravan|cartier|cba|cbn|cbre|cbs|cern|cfa|chanel|chase|chintai|chrome|chrysler|cisco|citadel|citi|citic|clubmed|comcast|commbank|creditunion|crown|crs|cuisinella|dabur|datsun|dealer|dell|deloitte|delta|dhl|discover|dish|dnp|dodge|dunlop|dupont|dvag|edeka|emerck|epson|ericsson|erni|esurance|etisalat|eurovision|everbank|extraspace|fage|fairwinds|farmers|FedEx|ferrari|ferrero|fiat|fidelity|firestone|firmdale|flickr|flir|flsmidth|ford|fox|fresenius|forex|frogans|frontier|fujitsu|fujixerox|gallo|gallup|gap|gbiz|gea|genting|giving|gle|globo|gmail|gmo|gmx|godaddy|goldpoint|goodyear|google|grainger|guardian|gucci|hbo|hdfc|hdfcbank|hermes|hisamitsu|hitachi|hkt|honda|honeywell|hotmail|hsbc|htc|hughes|hyatt|hyundai|ibm|ieee|ifm|ikano|imdb|infiniti|intel|intuit|ipiranga|iselect|itau|itv|iveco|jaguar|java|jcb|jcp|jeep|jpmorgan|juniper|kddi|kerryhotels|kerrylogistics|kerryproperties|kfh|kia|kindle|komatsu|kpmg|kred|kuokgroup|lacaixa|ladbrokes|lamborghini|lancaster|lancia|lancome|landrover|lanxess|lasalle|latrobe|lds|lego|liaison|lexus|lidl|lifestyle|lilly|lincoln|linde|lipsy|lixil|locus|lotte|lpl|lplfinancial|lundbeck|lupin|macys|maif|man|mango|marriott|maserati|mattel|mcd|mcdonalds|mckinsey|meo|metlife|microsoft|mini|mit|mitsubishi|mlb|mma|monash|mormon|moto|movistar|msd|mtn|mtpc|mtr|mutual|mutuelle|nadex|nationwide|natura|nba|nec|netflix|neustar|newholland|nexus|nfl|nhk|nico|nike|nikon|nissan|nissay|nokia|northwesternmutual|norton|nra|ntt|obi|office|omega|oracle|orange|orientexpress|otsuka|ovh|pamperedchef|panasonic|pccw|pfizer|philips|piaget|pictet|ping|pioneer|play|playstation|pohl|politie|praxi|prod|progressive|pru|prudential|pwc|quest|qvc|redstone|reliance|rexroth|ricoh|rmit|rocher|rogers|rwe|safety|sakura|samsung|sandvik|sandvikcoromant|sanofi|sap|saxo|sbi|sbs|sca|scb|schaeffler|schmidt|schwarz|scjohnson|scor|seat|sener|ses|sew|seven|sfr|seek|shangrila|sharp|shaw|shell|shriram|sina|skype|smart|sncf|softbank|sohu|Sony|spiegel|stada|staples|star|starhub|statebank|statefarm|statoil|stc|stcgroup|suzuki|swatch|swiftcover|symantec|taobao|target|tatamotors|tdk|telecity|telefonica|temasek|teva|tiffany|tjx|toray|toshiba|total|toyota|travelchannel|travelers|tui|tvs|ubs|unicom|uol|ups|vanguard|verisign|vig|viking|virgin|visa|vista|vistaprint|vivo|volkswagen|volvo|walmart|walter|weatherchannel|weber|weir|williamhill|windows|wme|wolterskluwer|woodside|wtc|xbox|xerox|xfinity|xperia|yahoo|yamaxun|yandex|yodobashi|youtube|zappos|zara|zip|zippo|ارامكو|‏اتصالات‎|联通|中信|xn--fiq64b|香格里拉|淡马锡|大众汽车|vermögensberater|xn--vermgensberater-ctb|vermögensberatung|xn--vermgensberatung-pwb|グーグル|xn--qcka1pmc|谷歌|xn--flw351e|工行|嘉里|嘉里大酒店|飞利浦|诺基亚|電訊盈科|香格里拉|淡马锡|大众汽车|삼성|xn--cg4bki|example|invalid|local|localhost|onion|test|إختبار|xn--kgbechtv|آزمایشی|xn--hgbk6aj7f53bba|测试|xn--0zwm56d|測試|xn--g6w251d|испытание|xn--80akhbyknj4f|परीक्षा|xn--11b5bs3a9aj6g|δοκιμή|xn--jxalpdlp|테스트|xn--9t4b11yi5a|טעסט|xn--deba0ad|テスト|xn--zckzah|பரிட்சை|xn--hlcj6aya9esc7a))(?:\\/|:|\\?|\\&|\\s|$)\\/?`,
    "gim"
  );
  const handleDomainCheck = (domain: string) => {
    setCustomDomainIsValid(domainRegex.test(domain));
  };

  const handleChange = (value: Color | string) => {
    setNavcolor(parseColor(value));
  };

  const handleTextChange = (value: Color | string) => {
    setNavtextcolor(parseColor(value));
  };

  const handleBgChange = (value: Color | string) => {
    setBgcolor(parseColor(value));
  };

  const onSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    let data = {
      navColour: colorToHexString(navcolor),
      colour1: colorToHexString(navtextcolor),
      colour2: colorToHexString(bgcolor),
      hideTitle,
    };

    getUserToken().then((token) => {
      if (window.location.href.indexOf("account") >= 0) {
        dispatch(updateAccountTheme(token!, id, data));
      } else {
        dispatch(updateOrgTheme(token!, id, data));
      }
    });
  };

  const hideTitleChanged = (event: ChangeEvent<HTMLInputElement>) => {
    setHideTitle(event.target.checked);
  };

  function handlePublicToggle() {
    dispatch(updateAccountVisibility(account.id, !account.public));
  }

  return (
    <Container maxWidth="lg" className={classes.container}>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Card>
            <CardHeader
              titleTypographyProps={{ variant: "h5" }}
              title={
                window.location.href.indexOf("account") >= 0
                  ? "Update this Accounts Theme"
                  : "Update Your Organisations Theme"
              }
            />
            <form
              onSubmit={(e) => {
                onSubmit(e);
              }}
            >
              <CardContent>
                <Box display="flex" alignItems="center">
                  <InputLabel style={{ color: "black", minWidth: "20vw" }}>
                    Nav Bar Colour
                  </InputLabel>
                  <Box
                    display="flex"
                    style={{ background: "#cecece61", margin: "20px" }}
                  >
                    <ColorPicker
                      value={navcolor}
                      defaultValue={navcolor}
                      onChange={handleChange}
                    />
                  </Box>
                </Box>
                <Box display="flex" alignItems="center">
                  <InputLabel style={{ color: "black", minWidth: "20vw" }}>
                    Nav Bar Text Colour
                  </InputLabel>
                  <Box
                    display="flex"
                    style={{ background: "#cecece61", margin: "20px" }}
                  >
                    <ColorPicker
                      value={navtextcolor}
                      onChange={handleTextChange}
                    />
                  </Box>
                </Box>
                <Box display="flex" alignItems="center">
                  <InputLabel style={{ color: "black", minWidth: "20vw" }}>
                    Background Colour
                  </InputLabel>
                  <Box
                    display="flex"
                    style={{ background: "#cecece61", margin: "20px" }}
                  >
                    <ColorPicker value={bgcolor} onChange={handleBgChange} />
                  </Box>
                </Box>
                <FormControlLabel
                  value={hideTitle}
                  control={<Checkbox color="primary" />}
                  checked={hideTitle}
                  onChange={(event) =>
                    hideTitleChanged(event as ChangeEvent<HTMLInputElement>)
                  }
                  label="Hide Navbar Text title"
                  labelPlacement="end"
                />
              </CardContent>
              <CardActions>
                <Button
                  variant="contained"
                  color="primary"
                  type="submit"
                  value="submit"
                  disabled={isAllowedToEdit}
                >
                  Update
                </Button>
              </CardActions>
            </form>
          </Card>
          {account && (
            <Card style={{ marginTop: "1rem" }}>
              <CardHeader title="Make this account public" />
              <CardContent>
                {account && account.public ? (
                  <Typography>
                    Toggle switch to make this account private. This will hide
                    this account from the public.
                  </Typography>
                ) : (
                  <Typography>
                    Toggle switch to make this account public. This will allow
                    anyone with the link to view this account.
                  </Typography>
                )}
                <Grid container alignItems="center">
                  <span>Private</span>
                  <Switch
                    onClick={handlePublicToggle}
                    checked={account?.public}
                    disabled={isLoading || isAllowedToEdit}
                  />
                  <span>Public</span>
                  {isLoading && (
                    <CircularProgress
                      style={{
                        width: "1rem",
                        height: "1rem",
                        marginLeft: "2rem",
                      }}
                    />
                  )}
                </Grid>
                {account && account.public && (
                  <>
                    <Typography
                      variant="body2"
                      style={{ marginTop: "0.75rem" }}
                    >
                      Your public account link:{" "}
                      <Link
                        href={`${window.location.origin}/view-account/${account.id}`}
                      >
                        {`${window.location.origin}/view-account/${account.id}`}
                      </Link>
                    </Typography>
                  </>
                )}
              </CardContent>
            </Card>
          )}
          <Card style={{ marginTop: "1rem" }}>
            <CardHeader
              titleTypographyProps={{ variant: "h5" }}
              title={"Add a custom domain"}
              action={
                <Chip
                  icon={<Star />}
                  size="small"
                  label="Paid Feature"
                  color="secondary"
                  variant="outlined"
                />
              }
            />
            <CardContent>
              <Box display="flex" flexDirection={"column"} alignItems="start">
                <Typography>
                  Please enter the domain you would like to use below. e.g.{" "}
                </Typography>
                <pre
                  style={{
                    fontSize: "14px",
                    backgroundColor: "#e9e9e9",
                    padding: "2px 6px",
                  }}
                >
                  reports.mydomain.com
                </pre>
                <Typography>
                  Click 'Request' to email to the support team your request. We
                  will configure the domain and send you an email with the next
                  steps.
                </Typography>
                <TextField
                  id="outlined-basic"
                  label="Custom Domain"
                  variant="outlined"
                  style={{ width: "100%", marginTop: "1rem" }}
                  value={customDomain}
                  onChange={(e) => {
                    setCustomDomain(e.target.value);
                    handleDomainCheck(e.target.value);
                  }}
                  error={customDomain.length > 0 && !customDomainIsValid}
                  helperText={
                    customDomain.length > 0 &&
                    !customDomainIsValid &&
                    "Please enter a valid subdomain or domain"
                  }
                />

                <Button
                  style={{ marginTop: "1rem" }}
                  variant="contained"
                  color="primary"
                  type="submit"
                  value="submit"
                  disabled={customDomain.length < 1 || !customDomainIsValid}
                  onClick={() => {
                    window.open(
                      `mailto:nick@thatapicompany.com?subject=Custom Domain Request: ${customDomain} : Organisation: ${id}&body=Please add the custom domain ${customDomain} to the organisation ${id}`,
                      "_blank"
                    );
                  }}
                >
                  Request
                </Button>
              </Box>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Container>
  );
}

const colorToHexString = (color: Color | undefined) =>
  color ? "#".concat(color.hex) : "";

const parseColor = (color: Color | string) =>
  typeof color === "object" ? color : createColor(color);

const useStyles = makeStyles((theme) => ({
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
  paper: {
    padding: theme.spacing(2),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
    marginRight: theme.spacing(2),
  },
  wrapper: {
    position: "relative",
    zIndex: 1,
    display: "inline-block",
  },
  button: {
    margin: theme.spacing(1),
    position: "absolute",
    bottom: "20px",
    left: "20%",
    alignSelf: "center",
  },
  input: {
    paddingLeft: theme.spacing(1),
  },
  width100: {
    width: "100%",
  },
  noWrap: {
    whiteSpace: "nowrap",
  },
}));

const mapStateToProps = (state: RootState, ownProps: ThemeProps) => {
  return {
    ...ownProps,
    theme: state.accounts.theme,
  };
};

export default connect(mapStateToProps)(Theme);
